import React, { FC } from "react";
import { BookingModal } from "../Booking/BookingModal/BookingModal";
import { BookingModal as BookingModalLegacy } from "../BookingLegacy/BookingModal/BookingModal";
import { BookingButtonViewModel } from "./BookingButtonViewModel.csharp";
import { useDecision } from "@optimizely/react-sdk";

interface BookingModalDecisionProps {
  bookingButton: BookingButtonViewModel;
  isModalOpened: boolean;
  ignorePersistedData?: boolean;
  closeModal: () => void;
}
export const BookingModalDecision: FC<BookingModalDecisionProps> = ({
  bookingButton,
  isModalOpened,
  closeModal,
  ignorePersistedData,
}) => {
  const [decision] = useDecision(
    bookingButton.optimizelyExperimentation?.enableNewBookingFlowKey ?? ""
  );

  const isNewBookingFlowEnabled =
    bookingButton.useNewBookingFlow && decision.enabled;

  const useNewBookingFlow = !!bookingButton.bookingVersion
    ? bookingButton.bookingVersion == 2
    : isNewBookingFlowEnabled;

  return useNewBookingFlow ? (
    <BookingModal
      closeModal={closeModal}
      isOpen={isModalOpened}
      disableBooking={bookingButton.disableBooking}
      modalThemeColor={bookingButton.modalThemeColor}
      breadcrumbs={bookingButton.breadcrumbs}
      showCloseButton={bookingButton?.showCloseButton}
      autostartBooking={bookingButton?.autoStartBooking}
      quickAppointmentSetup={bookingButton?.quickAppointmentSetup}
      ignorePersistedData={ignorePersistedData}
    />
  ) : (
    <BookingModalLegacy
      closeModal={closeModal}
      isOpen={isModalOpened}
      disableBooking={bookingButton.disableBooking}
      modalThemeColor={bookingButton.modalThemeColor}
      showCloseButton={bookingButton?.showCloseButton}
      autostartBooking={bookingButton?.autoStartBooking}
      ignorePersistedData={ignorePersistedData}
    />
  );
};
